import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE, Functionality } from '../context/Functionality';

export default function ProjectClientPicker({ value, onChange, disabled, purpose = 'project' }) {
  const { token } = useContext(Functionality);
  const [email, setEmail] = useState('');
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [refresh, setRefresh] = useState(0);
  useEffect(() => {
    let active = true;
    setData(null); setError('');
    const timer = setTimeout(() => {
    const params = new URLSearchParams({ clientsOnly: 'true', email: email.trim() });
    axios.get(`${API_BASE}/api/portals?${params}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => { if (active) setData(data); })
      .catch(() => { if (active) setError('Unable to load clients. Please retry.'); });
    }, 300);
    return () => { active = false; clearTimeout(timer); };
  }, [token, email, refresh]);
  return <fieldset disabled={disabled} className="rounded-lg border p-4 space-y-3">
    <legend className="font-semibold">Assign to a client</legend>
    <p className="text-sm text-gray-600">Choose an existing verified non-employee account. {purpose === 'assessment' ? 'Employees manage the forms and share links with respondents. Nothing is added to the client portal.' : 'Only this client and employees can access the project.'}</p>
    <label className="block">Search clients by email<input type="search" maxLength={254} className="mt-1 block w-full rounded-lg border border-gray-300 p-3" placeholder="Enter all or part of an email address" value={email} onChange={event => setEmail(event.target.value)} /></label>
    {value && <p role="status">Selected client: {value.owner.firstName} {value.owner.lastName} ({value.owner.email})</p>}
    {error && <div><p role="alert">{error}</p><button type="button" className="underline" onClick={() => setRefresh(value => value + 1)}>Retry clients</button></div>}
    {!data && !error && <p role="status">Loading clients…</p>}
    {data && <><div className="max-h-64 overflow-y-auto space-y-2">{data.portals.map(client => <label key={client.id} className="flex items-center gap-3 rounded border p-3">
      <input type="radio" name="project-client" checked={value?.id === client.id} onChange={() => onChange(client)} />
      <span>{client.owner.firstName} {client.owner.lastName} — {client.owner.email}</span>
    </label>)}</div>{!data.portals.length && <p>No matching client accounts.</p>}
    {data.hasMore && <p className="text-sm text-gray-600">Showing the first 50 matches. Enter more of the email address to narrow the results.</p>}</>}
  </fieldset>;
}
